module.exports = __webpack_public_path__ + "img/index1.0d528ea9.jpg";